import type { FC } from 'react';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { BlockDesktop as Block } from '@alfa-bank/site-block/desktop';

import type { TChangingAddressDesktop } from '../model';
import { closeModalStep } from '../../../store';
import { defaultChangingAddressSettings } from '../config/default-values';

export const ChangingAddressDesktop: FC<TChangingAddressDesktop> = ({
    Button,
    List,
    Modal,
    Text,
    buttonLink = defaultChangingAddressSettings.buttonLink,
    buttonText = defaultChangingAddressSettings.buttonText,
    description = defaultChangingAddressSettings.description,
    directions = defaultChangingAddressSettings.directions,
    title = defaultChangingAddressSettings.title,
}) => {
    const dispatch = useDispatch();

    const handleCloseModal = useCallback(() => {
        dispatch(closeModalStep());
    }, [dispatch]);

    return (
        <Modal onClose={handleCloseModal} size="m">
            <Text styler={{ marginTop: 0, marginBottom: 24 }} view="medium">
                {title}
            </Text>
            <Text styler={{ marginTop: 0, marginBottom: 24 }} view="primary-medium">
                {description}
            </Text>
            <Block notPadded styler={{ marginBottom: 24 }}>
                <List indentType="12" marker="" olRedMarker olType="1" type="ol">
                    {directions?.map(direction => (
                        <Text
                            key={direction}
                            styler={{ marginTop: 0, marginBottom: 0 }}
                            view="primary-medium"
                        >
                            {direction}
                        </Text>
                    ))}
                </List>
            </Block>
            {/* TODO нет rel noopener noreferrer */}
            <Button href={buttonLink} size="s" view="primary">
                {buttonText}
            </Button>
        </Modal>
    );
};
